"use client"
import axios from 'axios';
import { API_CONFIG } from '../config';
import { safeGetItem, safeNavigate, safeRemoveItem } from '../utils/localStorage';
export const axiosInstance = axios.create({
  baseURL: `${API_CONFIG.baseURL}/api/${API_CONFIG.version}`,
  timeout: API_CONFIG.timeout,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  },

})

axiosInstance.interceptors.request.use(
  (config) => {
    // Add auth token if exists
    const token = safeGetItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      //config.headers['Content-Type'] ='application/json'
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
let isRedirectingAfter401 = false;

axiosInstance.interceptors.response.use(
  (response) => {
    if (typeof response.data === 'string' && response.data.includes('}{')) {
      // Prendre seulement la deuxième partie du JSON (la réponse réelle)
      const cleanedData = response.data.split('}{')[1];
      response.data = JSON.parse(`{${cleanedData}`);
    }
    return response;
  },
  async (error) => {
    if (error.response?.status === 401) {
      const requestUrl = String(error.config?.url ?? '');
      const isUnauthenticatedAuthEndpoint =
        requestUrl.includes('/auth/login') ||
        requestUrl.includes('/auth/demo');
      if (isUnauthenticatedAuthEndpoint) {
        return Promise.reject(error);
      }
      // Clear auth token and redirect to auth page
      if (!isRedirectingAfter401) {
        isRedirectingAfter401 = true;
        try {
          safeRemoveItem('token');
        } finally {
          // Prefer docs app auth route
          safeNavigate('/auth/login');
        }
      }
    }
    return Promise.reject(error);
  }
);
